import { useStaticQuery, graphql } from "gatsby"

export const useApplication = () => {
  const menu = useStaticQuery(graphql`
    query UseApplicationQuery {
      allDatoCmsApplicationPage(sort: { fields: position }) {
        nodes {
          id
          position
          locale
          _allSlugLocales {
            locale
            value
          }
          title
          slug
        }
      }
    }
  `)

  return menu.allDatoCmsApplicationPage.nodes.sort(
    (a, b) => a.position - b.position
  )
}
